require('./bootstrap');

import {ConfigSetup} from './bootstrap';

import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import FullCalendar from 'vue-full-calendar';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../public/css/custom.css';
import 'fontsource-montserrat/300-normal.css';

import MultiSelect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import 'popper.js';
import {library} from '@fortawesome/fontawesome-svg-core';


import {
  faCoffee,faChild,faCircle,faArchive,faComment,faSignInAlt,
  faEyeSlash,faEye,faStepBackward,faStepForward,faBars,faUserFriends,
  faBookmark,faCalendarDay,faCalendarAlt,faHome,faAngleDown,faCogs,
  faChartArea,faEdit,faFileDownload,faFileUpload,faFile,faUndo,faPrint,
  faBook,faTimes,faSignOutAlt,faArrowsAltH,faWindowClose,faSave,faBan,
  faSearch,faPlus,faCheck,faHotel,faExchangeAlt,faTrash, faArrowRight,
  faExclamation, faUserPlus,faPaperclip,faComments,faCommentDots,faCaretDown,
  faCaretUp,faTachometerAlt,faAsterisk,faMailBulk
} from '@fortawesome/free-solid-svg-icons';

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';

library.add(
    faCoffee, faChild,
    faCircle, faArchive, faComment, faSignInAlt, faEyeSlash, faEye,
    faStepBackward, faStepForward, faBars,
    faUserFriends, faBookmark, faCalendarDay, faCalendarAlt, faHome,
    faAngleDown, faCogs, faChartArea,
    faEdit, faBookmark, faFileDownload, faFileUpload, faFile, faUndo, faPrint,
    faBook, faTimes, faSignOutAlt,
    faArrowsAltH, faWindowClose, faArrowsAltH, faSave, faBan, faSearch, faPlus,
    faCheck, faHotel, faExchangeAlt, faTrash, faArrowRight, faExclamation,faComments,
    faCommentDots,faCaretDown,faCaretUp,faUserPlus,faPaperclip,faTachometerAlt,faAsterisk,faMailBulk
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
Vue.component('multiSelect', MultiSelect);

import $ from 'jquery';

Vue.config.productionTip = false;
Vue.use(require('vue-moment'));
Vue.use(FullCalendar);
//todo put all the config here.
ConfigSetup.initAxios();
ConfigSetup.initProgressBar();
ConfigSetup.initSweetAlert2();
ConfigSetup.initGlobalElementFocus();


global.$ = $;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
